export const YELLOW = "#FBD437";
export const DARK_GRAY = "#333"
